import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import { ArrowLeft, Sparkles } from "lucide-react";

interface HeaderProps {
  title: string;
  description?: string;
  showBack?: boolean;
  backPath?: string;
}

const Header = ({ title, description, showBack = true, backPath = "/dashboard" }: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50 w-full border-b border-border">
      <div className="container flex h-14 max-w-screen-2xl items-center">
        <div className="flex items-center space-x-2 md:mr-6">
          {showBack && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => navigate(backPath)}
              className="mr-4 hover:bg-accent hover:text-accent-foreground"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
          )}
          <div className="hidden md:flex">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="font-semibold">PromptPerfect</span>
            </Link>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center">
          <h1 className="text-lg font-semibold text-foreground">
            {title}
          </h1>
        </div>

        <div className="flex items-center justify-end space-x-4">
          <ThemeToggle />
          <Button variant="default" size="sm" asChild>
            <Link to="/dashboard">Dashboard</Link>
          </Button>
        </div>
      </div>
      {description && (
        <div className="container mx-auto px-6 py-8 border-b border-border">
          <p className="text-xl text-muted-foreground max-w-2xl">
            {description}
          </p>
        </div>
      )}
    </header>
  );
};

export default Header; 